import axios from 'axios';
import AuthenticationService from '@/auth/AuthenticationService';
import settings from '@/settings.json';

const baseUrl = settings.api;

const instance = axios.create({
    baseURL: baseUrl,
});

instance.interceptors.request.use(async (config) => {
    const token = await (new AuthenticationService().getAccessToken());
    if ( token != null ) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}, (err) => {
    return Promise.reject(err);
});

export default instance;
